import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  TwoOffersLock_OfferLockDataFragment,
  TwoOffersLock_ViewerFragment,
} from './__generated__/two-offers-lock.graphql'
import styles from './two-offers-lock.module.scss'
import { TwoOffersLockContent } from './two-offers-lock-content'

export interface TwoOffersLockProps {
  offerLockData: TwoOffersLock_OfferLockDataFragment
  viewer: TwoOffersLock_ViewerFragment
}

export function TwoOffersLock({ offerLockData, viewer }: TwoOffersLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = <TwoOffersLockContent viewer={viewer} offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles['paywall-two-offers-lock']}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

TwoOffersLock.fragments = {
  offerLockData: gql`
    fragment TwoOffersLock_offerLockData on OfferLockData {
      ...TwoOffersLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${PaywallLock.fragments.offerLockData}
    ${TwoOffersLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment TwoOffersLock_viewer on Profile {
      ...TwoOffersLockContent_viewer
    }
    ${TwoOffersLockContent.fragments.viewer}
  `,
}
